export function getSafeNodeId (id) {
  // when using JS objects to construct Immutable Maps,
  // that JavaScript Object properties are always strings,
  // even if written in a quote-less shorthand, while Immutable Maps accept keys of any type.
  // Property access for JavaScript Objects first converts the key to a string,
  // but since Immutable Map keys can be of any type the argument to get() is not altered.
  // So for consistency it's much more safe to treat id as string
  return String(id)
}

/**
 * Test if the id is a valid node id
 * @param {*} id The id to test
 * @returns {Boolean} True if this is a valid node Id
 */
export function isValidNodeId (id) {
  return /^[0-9]+$/.test(id)
}
